<set-widget [entity]="this.entity" [layout]="this.layout" [options]="options" [title]="'Incoming Callbacks'"></set-widget>
  